import React from 'react';

export const NotionSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-211.5"
				y="-263.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="white" />
			<rect x="0.5" y="0.5" width="31" height="31" rx="7.5" stroke="#0B1228" strokeOpacity="0.14" />
			<path
				d="M7.63209 6.86307L18.6985 6.04568C20.0578 5.92908 20.407 6.00768 21.2618 6.62907L24.7944 9.11762C25.3769 9.54561 25.5709 9.66221 25.5709 10.1282V23.7765C25.5709 24.6319 25.2604 25.1379 24.173 25.2151L11.322 25.9935C10.506 26.0321 10.1174 25.9155 9.69005 25.3709L7.0887 21.9882C6.62211 21.3656 6.42871 20.8996 6.42871 20.3548V8.22304C6.42871 7.52365 6.7393 6.94046 7.63209 6.86307Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.6985 6.04588L7.63209 6.86327C6.7393 6.94046 6.42871 7.52385 6.42871 8.22304V20.3548C6.42871 20.8994 6.62211 21.3654 7.0887 21.9882L9.69005 25.3707C10.1174 25.9153 10.506 26.0321 11.322 25.9933L24.1732 25.2153C25.2597 25.1379 25.5711 24.6319 25.5711 23.7767V10.1284C25.5711 9.68641 25.3965 9.55901 24.8826 9.18182L21.2618 6.62907C20.4072 6.00768 20.0578 5.92908 18.6985 6.04568V6.04588ZM11.6126 9.90501C10.5632 9.97561 10.3252 9.99161 9.72925 9.50701L8.21408 8.30184C8.06008 8.14584 8.13748 7.95125 8.52547 7.91245L19.1639 7.13506C20.0572 7.05706 20.5224 7.36846 20.8718 7.64045L22.6964 8.96243C22.7744 9.00182 22.9684 9.23442 22.735 9.23442L11.7486 9.89581L11.6126 9.90501ZM10.3892 23.6601V12.0738C10.3892 11.5678 10.5446 11.3344 11.0098 11.2952L23.6284 10.5564C24.0564 10.5178 24.2498 10.7898 24.2498 11.295V22.8042C24.2498 23.3101 24.1718 23.7381 23.4732 23.7767L11.398 24.4767C10.6994 24.5153 10.3894 24.2827 10.3894 23.6601H10.3892ZM22.309 12.695C22.3864 13.0449 22.309 13.3949 21.959 13.4349L21.377 13.5503V22.1048C20.8716 22.3768 20.4064 22.5322 20.0176 22.5322C19.3963 22.5322 19.2411 22.3376 18.7757 21.7548L14.9697 15.7669V21.5602L16.1737 21.8328C16.1737 21.8328 16.1737 22.5328 15.2023 22.5328L12.5244 22.6882C12.4464 22.5322 12.5244 22.1436 12.7958 22.0662L13.4952 21.8722V14.2123L12.5246 14.1337C12.4466 13.7837 12.6406 13.2783 13.1846 13.2391L16.0579 13.0457L20.0178 19.111V13.7451L19.0085 13.6291C18.9305 13.2005 19.2411 12.8892 19.6291 12.8512L22.309 12.695Z"
				fill="#292A2E"
			/>
		</svg>
	);
};
